import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { DEFAULT_ICON_BUTTON, DEFAULT_ICON_BUTTON_HOVER, DEFAULT_ICON_BUTTON_DISABLED } from 'visitor-ui-component-library/theme/ColorConstants';
import I18n from 'I18n';
import styled from 'styled-components';
import SVGSendOutline from 'visitor-ui-component-library-icons/icons/SVGSendOutline';
import { jsx as _jsx } from "react/jsx-runtime";
const Button = styled.button.withConfig({
  displayName: "SendButton__Button"
})(["border:none;padding:0;width:30px;height:30px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:14px;margin:auto;background-color:transparent;&:focus-visible{outline-offset:1px;outline:2px solid #00a4bd;}&:hover{& svg{fill:", ";}}&[disabled]{cursor:not-allowed;background-color:transparent;color:", ";& svg{fill:", ";}}"], DEFAULT_ICON_BUTTON_HOVER, DEFAULT_ICON_BUTTON_DISABLED, DEFAULT_ICON_BUTTON_DISABLED);
const SendIcon = styled(SVGSendOutline).withConfig({
  displayName: "SendButton__SendIcon"
})(["width:18px;height:18px;margin-right:2px;fill:", ";"], DEFAULT_ICON_BUTTON);
export function SendButton(_ref) {
  let props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(Button, Object.assign({
    "aria-label": I18n.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.send'),
    "data-test-id": "chat-send-button"
  }, props, {
    children: /*#__PURE__*/_jsx(SendIcon, {})
  }));
}
SendButton.displayName = 'SendButton';